module.exports = __webpack_public_path__ + "static/media/Control.2d3a3be7.svg";